import React from 'react';
import { Advertisement } from '../../services/advertisementService';
import { AdvertisementType } from '../../services/advertisementService';
import styles from '../../styles/shared/CardGrid.module.css';
import placeholderImage from '../../assets/placeholder.png';

interface AdvertisementCardProps {
  advertisement: Advertisement;
  onEdit: (advertisement: Advertisement) => void;
  onDelete: (id: number) => void;
  onToggleActive?: (advertisement: Advertisement) => void;
  getTypeLabel: (type: AdvertisementType) => string;
}

const AdvertisementCard: React.FC<AdvertisementCardProps> = ({ 
  advertisement, 
  onEdit, 
  onDelete,
  onToggleActive,
  getTypeLabel 
}) => {
  const imageUrl = advertisement.image_url;

  return (
    <div className={styles.card}>
      <div className={styles.imageContainer}>
        {imageUrl ? (
          <img 
            src={imageUrl} 
            alt={advertisement.title}
            className={styles.cardImage}
            onError={(e) => {
              e.currentTarget.src = placeholderImage;
            }}
          />
        ) : (
          <div className={styles.placeholderImage}>
            <span>📢</span>
          </div>
        )}
      </div>
      
      <div className={styles.cardContent}>
        <h3 className={styles.cardTitle}>{advertisement.title}</h3>
        <p className={styles.cardDescription}>{advertisement.brief}</p>
        
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '8px', marginBottom: '12px' }}>
          <span style={{
            display: 'inline-block',
            padding: '4px 8px',
            backgroundColor: '#e3f2fd',
            color: '#1976d2',
            borderRadius: '12px',
            fontSize: '12px',
            fontWeight: 500
          }}>
            {getTypeLabel(advertisement.type)}
          </span>
          <span style={{
            display: 'inline-block',
            padding: '4px 8px',
            backgroundColor: advertisement.is_active ? '#4caf50' : '#999',
            color: 'white',
            borderRadius: '12px',
            fontSize: '12px',
            fontWeight: 500
          }}>
            {advertisement.is_active ? 'Active' : 'Inactive'}
          </span>
        </div>
        
        <div className={styles.cardActions}>
          {onToggleActive && (
            <button 
              onClick={() => onToggleActive(advertisement)} 
              className={`${styles.cardActionButton} ${advertisement.is_active ? styles.cardDisableButton : styles.cardEnableButton}`}
            >
              {advertisement.is_active ? 'Disable' : 'Enable'}
            </button>
          )}
          <button 
            onClick={() => onEdit(advertisement)} 
            className={`${styles.cardActionButton} ${styles.cardEditButton}`}
          >
            Edit
          </button>
          <button 
            onClick={() => onDelete(advertisement.id)} 
            className={`${styles.cardActionButton} ${styles.cardDeleteButton}`}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdvertisementCard;
